import styled from "styled-components"
import { Step } from "./types"

interface StepProps {
  step: Step
  currentOption: number
  isCurrentStep: boolean
  isCurrentStepActive: boolean
  isCurrentStepExpand: boolean
  isExpanded: boolean
  onStepChange: () => void
  handleOptionChange: (option: number) => void
}

const Options = styled.div`
  display: flex;
  align-items: center;

  .step {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;

    .circle {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid gray;
      z-index: 2;
      background-color: white;

    }
    .label {
      text-align: center;
      font-size: 15px;
      white-space: pre-line;
    }
  }

  .step.active {
    animation: pulse 1s infinite;
    .circle {
      border: 2px solid red;
    }
    .label {
      color: red;
    }
  }

  @media (max-width: 500px) {
    .step {
      .circle {
        width: 30px;
        height: 30px;
        border: 2px solid gray;
      }
      .label {
        display: inline-block;
        white-space: nowrap;
        font-size: 11px;
      }
    }

    .step.active {
      .circle {
        border: 2px solid red;
      }
      .label {
        color: red;
      }
    }
  }
  
}
`

const SubOptions = styled.div`
  display: flex;
  flex-grow: 1;
  width: auto;
  gap: 50px;

  @media (max-width: 500px) {
    gap: 14px;
  }

  @media (min-width: 768px) {
    gap: 25px;
  }

  .sub-options {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .sub-circle {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid gray;
      z-index: 2;
      background-color: white;
    }
    .sub-label {
      grid-area: sub-label;
      font-size: 11px;
      text-align: center;
      white-space: pre-line;
    }
  }

  .sub-options.active {
    animation: pulse 1s infinite;
    position: relative;

    .sub-circle {
      border: 2px solid red;
      z-index: 3;
      background-color: white;
    }
    .sub-label {
      color: red;
    }
  }

  @media (max-width: 500px) {
    .sub-options {
      .sub-circle {
        width: 20px;
        height: 20px;
        border: 2px solid gray;
        font-size: 11px;
      }
      .sub-label {
        display: inline-block;
        white-space: nowrap;
        font-size: 8px;
      }
    }

    .sub-options.active {
      .sub-circle {
        border: 2px solid red;
      }
      .sub-label {
        color: red;
      }
    }
  }
`

function cutSlash(inputString: string): string {
  const secondSlashIndex = inputString.indexOf(
    "/",
    inputString.indexOf("/") + 1
  )

  if (secondSlashIndex !== -1) {
    const firstPart = inputString.substring(0, secondSlashIndex)
    const secondPart = inputString.substring(secondSlashIndex + 1)
    return `${firstPart}\n${secondPart}`
  } else {
    return inputString
  }
}

function cutSpace(inputString: string): string {
  const words = inputString.split(" ")
  if (words.length > 1) {
    return words.join("\n")
  }
  return inputString
}

export default function ProgressStep({
  step,
  currentOption,
  isCurrentStep,
  isCurrentStepActive,
  isCurrentStepExpand,
  isExpanded,
  handleOptionChange,
  onStepChange,
}: StepProps) {
  return (
    <>
      <Options>
        <div
          className={`step ${
            isCurrentStep || isCurrentStepActive ? "active" : ""
          }`}
          onClick={() => {
            onStepChange()
          }}
        >
          <div className="circle">{step.icon}</div>
          <div className="label">{cutSpace(step.label)}</div>
        </div>
      </Options>

      {step.options &&
        step.label !== "Summary" &&
        isExpanded &&
        isCurrentStepExpand && (
          <SubOptions>
            {step.options?.map((option, optionIndex) => (
              <div
                key={optionIndex}
                className={`sub-options ${
                  isCurrentStep && optionIndex === currentOption ? "active" : ""
                }`}
                onClick={() => handleOptionChange(optionIndex)}
              >
                <div className="sub-circle">{option.iconLabel}</div>

                <div className="sub-label">{cutSlash(option.label)}</div>
              </div>
            ))}
          </SubOptions>
        )}
    </>
  )
}
